export default __webpack_public_path__ + "static/CTA_Default-5d647f9be0962f95a38ba274575e1396.png";